export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ08.4f2c24a2.mp3";